<template>
  <div>

    <div class="mt-3 col-md-12">
      <div class="shadow p-3 mb-2 bg-body rounded d-flex align-items-center">
        <input type="search" class="form-control" id="exampleInputEmail1" placeholder="جست و جوی سرویس ..."
          v-model="search">
      </div>
    </div>

    <div class="text-center mt-5" v-if="get_data_loading">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden"></span>
      </div>
    </div>
    <div class="row" v-else>
      <div class="mt-3 col-md-12" v-for="storage in storages" :key="storage">
        <div class="shadow p-3 mb-3 bg-body rounded d-flex align-items-center">
          {{ storage.size }} GB
          <span class="badge rounded-pill bg-warning me-1" v-if="storage.status == 'pending'">انتظار</span>
          <span class="badge rounded-pill bg-success me-1" v-if="storage.status == 'active'">فعال</span>
          <span class="badge rounded-pill bg-danger me-1" v-if="storage.status == 'finished'">پایان</span>
          <span class="badge rounded-pill bg-secondary me-1">{{ storage.user.name }}</span>
          <button class="btn btn-primary me-auto" data-bs-toggle="modal" data-bs-target="#storage"
            @click="getStorage(storage._id)">مدیریت</button>
        </div>
      </div>
    </div>

    <nav aria-label="Page navigation" dir="ltr">
      <ul class="pagination justify-content-center">
        <li v-for="p in page" :key="p" class="page-item">
          <a v-if="p == active_page" class="page-link active" href="#" @click="getData(p)">{{ p }}</a>
          <a v-else class="page-link" href="#" @click="getData(p)">{{ p }}</a>
        </li>
      </ul>
    </nav>


    <!--Storage Modal-->
    <div class="modal fade" id="storage" tabindex="-1">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="btn-close" data-bs-dismiss="modal" ref="modal"></button>
            <h5 class="modal-title" id="exampleModalLabel">ویرایش</h5>
          </div>
          <div class="modal-body">
            {{ data }}
          </div>
          <div class="modal-footer">

          </div>
        </div>
      </div>
    </div>


  </div>
</template>

<script>
import { ref } from 'vue';
import { inject } from '@vue/runtime-core';
import axios from 'axios';
import { onMounted, watch } from '@vue/runtime-core';
export default {
  setup() {
    const loading = ref(false);
    const get_data_loading = ref(true);
    const toast = inject("toast");
    const modal = ref();
    const storages = ref([]);
    const data = ref({});
    const page = ref(1);
    const active_page = ref(0);
    const search = ref('')

    function send() {
      loading.value = true;
      axios.post('/admin/new-service', data.value)
        .then(function (response) {
          getData(1)
          loading.value = false;
          toast.success("افزودن سرور با موفقیت انجام شد");
          modal.value.click();
        })
        .catch(function (error) {
          toast.error("افزودن سرور با خطا مواجه شد");
          loading.value = false;
          modal.value.click();
          console.log(error);
        })
    }
    function getData(page_id, search = '') {
      active_page.value = page_id;
      axios.post('/admin/get-storages', { page: page_id, search })
        .then(function (response) {
          storages.value = response.data.storages;
          if (response.data.page != null) {
            page.value = parseInt(response.data.page / 20) + 1;
          }
          get_data_loading.value = false;
        })
        .catch(function (error) {
          console.log(error);
          get_data_loading.value = false;
        })
    }

    function getStorage(id) {
      axios.post('/admin/get-storage', { id: id })
        .then(function (response) {
          data.value = response.data
          get_data_loading.value = false;
        })
        .catch(function (error) {
          console.log(error);
          get_data_loading.value = false;
        })
    }
    onMounted(() => {
      getData(1)
    })

    watch(search, (sr) => {
      getData(1, sr)
    })

    return { get_data_loading, loading, modal, send, storages, data, getStorage, page, active_page, getData, search }
  }

}
</script>

<style></style>